import type {ReactAction} from '@netx/core/bootstrap';
import {faTimes} from '@fortawesome/pro-solid-svg-icons';
import {canCategorizeRemoveCurrentCartAssets} from '../enablers';
import {CART_CURRENT_ACTION_LABELS} from '../locales';
import {CART_CURRENT_EVENT} from './constants';

/**
 * Remove cart assets from folder
 * @param params
 * @returns Action
 */
export const cartActionCategorizeRemove = (
	params: Partial<ReactAction> = {},
): ReactAction => ({
	name: 'cart-current-categorize-remove',
	cb: () => dispatcher.trigger(CART_CURRENT_EVENT.CATEGORIZE_REMOVE),
	enableTest: () => canCategorizeRemoveCurrentCartAssets(),
	icon: faTimes,
	get label() {
		return CART_CURRENT_ACTION_LABELS.CATEGORIZE_REMOVE;
	},
	...params,
});

export default cartActionCategorizeRemove;
